export default "__VITE_ASSET__dd2cc83c__"